import React, { FC } from 'react'
import { ArtworksList, NoResults, ArtworkListWrapper } from 'components/Artworks/styles/list'
import ListConnector, { ConnectorProps as ListProps } from '../../connectors/List'
import Artwork from './Artwork'

const ShowsArtworksList: FC<ListProps> = (props) => {
  const { artworks, isMobileTraffic, isMobileScreen, isReady } = props
  const isMobile = isMobileScreen && isReady
  // PDPs to open in new tabs when in *Desktop* view (NON mobile devices)
  const shouldOpenNewDesktopPdpTab = !isMobileTraffic
  return (
    <>
      <ArtworkListWrapper>
        {!artworks.length ? (
          <NoResults>Sorry, no results were found for that query.</NoResults>
        ) : (
          <>
            <ArtworksList data-device={isMobile ? 'mobile' : 'desktop'} data-type='artworks-list'>
              {artworks.map((artwork, index) => {
                const { artworkId, hasPrints } = artwork
                const priority = index === 0
                const lazyLoad = index > 6
                return (
                  <Artwork
                    shouldOpenNewDesktopPdpTab={shouldOpenNewDesktopPdpTab}
                    artwork={artwork}
                    artworkId={artworkId}
                    hasPrints={hasPrints}
                    index={index}
                    isMobile={isMobile}
                    key={`artwork-${artworkId}`}
                    priority={priority}
                    lazyLoad={lazyLoad}
                  />
                )
              })}
            </ArtworksList>
          </>
        )}
      </ArtworkListWrapper>
    </>
  )
}

export default ListConnector(ShowsArtworksList)
